import axios from 'axios';
import Candidate from '../entity/candidate/candidate.entity';
import CandidatePersonalityResult from '../entity/candidate/candidate-personality-result.entity';
import CandidateReasoningResult from '../entity/candidate/candidate-reasoning-result.entity';
import CandidateCultureGradeDetails from '../entity/candidate/candidate-culture-grade-details.entity';

export default class CandidateService {
  public static findCandidateByName(name: string): Promise<Candidate[]> {
    return axios.get(`/api/candidate?name=${name}`)
      .then(({ data }) => data.map(it => new Candidate(it)));
  }

  public static existsByEmail(email: string) {
    return axios.get(`/api/public/candidate/exists/${email}`);
  }

  public static async getPersonalityResult(
    candidateAssessmentId: string,
  ): Promise<CandidatePersonalityResult> {
    return axios.get(`/api/candidate/personality/${candidateAssessmentId}`)
      .then(({ data }) => new CandidatePersonalityResult(data));
  }

  public static async getReasoningResult(
    candidateAssessmentId: string,
  ): Promise<CandidateReasoningResult[]> {
    return axios.get(`/api/candidate/reasoning-result/${candidateAssessmentId}`)
      .then(({ data }) => data.map(it => new CandidateReasoningResult(it)));
  }

  public static async getCultureResult(
    candidateAssessmentId: string,
  ): Promise<CandidateCultureGradeDetails> {
    return axios.get(`/api/candidate/culture-survey-result/${candidateAssessmentId}`)
      .then(({ data }) => new CandidateCultureGradeDetails(data));
  }
}
